var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5362 5.42531L11.0172 0.65954C10.5341 0.242337 9.77277 0.581022 9.77277 1.22911V3.73931C4.73595 3.79698 0.742004 4.80645 0.742004 9.57977C0.742004 11.5064 1.98314 13.415 3.35506 14.4129C3.78318 14.7243 4.39332 14.3334 4.23547 13.8287C2.81362 9.2815 4.90986 8.07433 9.77277 8.00437V10.7611C9.77277 11.4102 10.5347 11.7474 11.0172 11.3307L16.5362 6.56444C16.8833 6.2646 16.8838 5.72555 16.5362 5.42531Z",
    fill: "#0096FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueExport);
export default __webpack_public_path__ + "static/media/blueExport.9484cfd341906f7b09c641c1e39e1f5d.svg";
export { ForwardRef as ReactComponent };